// extracted by mini-css-extract-plugin
export default {"right":"styles_right__Fj7cw","arrows":"styles_arrows__BSLa3","icon-button":"styles_icon-button__Hc-DW"};